import React from 'react'
import Header from '../../components/Header/Header'
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs'
import { Box, Container } from '@mui/material'
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop'
import Footer from '../../components/Footer/Footer'
import { Route, Routes, useLocation } from 'react-router-dom'
import { ROUTES } from '../../constants'
import Home from '../../pages/Home/Home'
import MyMachines from '../../pages/MyMachines/MyMachines'
import Products from '../../pages/Products/Products'
import SingleProduct from '../../pages/SingleProduct/SingleProduct'
import Recommendations from '../../pages/Recommendations/Recommendations'
import Cart from '../../pages/Cart/Cart'
import Checkout from '../../pages/Checkout/Checkout'
import OrderConfirmation from '../../pages/OrderConfirmation/OrderConfirmation'
import OrderHistory from '../../pages/OrderHistory/OrderHistory'
import Settings from '../../pages/Settings/Settings'
import Profile from '../../pages/Profile/Profile'
import Admin from '../../pages/Admin/Admin'
import Rspl from '../../pages/Rspl/Rspl'
import Documents from '../../pages/Documents/Documents'
import Requests from '../../pages/Requests/Requests'
import Support from '../../pages/Support/Support'
import Analytics from '../../pages/Analytics/Analytics'
import ProtectedRoute from '../../ProtectedRoute'
import AdminRoute from '../../AdminRoute'
import PDFProductLinkMachineFinder from '../../components/PDFProductLinkMachineFinder/PDFProductLinkMachineFinder'
import Services from '../../pages/Services/Services'
import SavedForLater from "../../pages/SavedForLater/SavedForLater";
import PageNotFound from '../../pages/PageNotFound/PageNotFound'
import AdminV2 from '../../pages/Admin/AdminV2'
import SearchResults from '../../pages/SearchResults/SearchResults'
import TrackOrder from '../../pages/TrackOrder/TrackOrder'
import OrderFailure from '../../pages/OrderFaliure/OrderFaliure'
import NotificationsPage from '../../pages/Notifications/Notifications'
import ModelViewer from '../../pages/ModelViewer/ModelViewer'
import MarkdownHelpPage from '../../components/MarkDown/MarkeDownPopup'
import NotAuthorized from '../../components/NotAuthorized/NotAuthorized'
import { useAuth } from '../../context/authContext'
import { canAccessCart, canAccessOrderAnalytics, canAccessSettings, canAccessUserAnalytics } from '../../utilities/pageAccess'
import UserAnalytics from '../../pages/UserAnalytics/UserAnalytics'
import BannerNotice from '../../components/BannerNotice/BannerNotice'

const DefaultLayout = () => {
    const location = useLocation();
    const { user, hasPermission } = useAuth();

    const noBreadcrumPaths = [ROUTES.HOME, ROUTES.HOME_ALIAS, "/admin-v2", "/admin", "/model-viewer"];
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh" width={"100vw"}>
            <Header />
            <BannerNotice />

            {!noBreadcrumPaths.includes(location.pathname) && (
                <BreadCrumbs />
            )}
            <Container maxWidth={false} component="main" className="main-container">
                <Routes>
                    <Route path={ROUTES.HOME} element={<Home />} />
                    <Route path={ROUTES.HOME_ALIAS} element={<Home />} />
                    <Route path={ROUTES.MACHINES} element={<MyMachines />} />
                    <Route path={`/${ROUTES.MACHINES}/:machineID`} element={<Products />} />
                    <Route path={`/${ROUTES.MACHINES}/:machineID/:productID`} element={<SingleProduct />} />
                    <Route path={ROUTES.RECOMMENDATIONS} element={<Recommendations />} />
                    <Route path={ROUTES.CART} element={<Cart />} />
                    <Route path={ROUTES.CHECKOUT} element={<Checkout />} />
                    <Route path={ROUTES.ORDER_RECEIVED} element={<OrderConfirmation />} />
                    <Route path={"/order-failure"} element={<OrderFailure />} />
                    <Route path={ROUTES.ORDER_ERROR} element={<OrderConfirmation />} />
                    <Route path={ROUTES.ORDER_HISTORY} element={<OrderHistory />} />
                    <Route path={ROUTES.ORDER_PRODUCT_DETAILS} element={<OrderHistory />} />
                    <Route path={ROUTES.ORDERS_DETAILS} element={<OrderHistory />} />
                    <Route path={ROUTES.TRACK_ORDER} element={canAccessCart(hasPermission) ? <TrackOrder /> : <NotAuthorized />} />
                    <Route path={ROUTES.SETTINGS} element={canAccessSettings(user) ? <Settings /> : <NotAuthorized />} />
                    <Route path={ROUTES.PROFILE} element={<Profile />} />
                    <Route path={ROUTES.ADMIN} element={<Admin />} />
                    <Route path={ROUTES.RSPL} element={<Rspl />} />
                    <Route path={ROUTES.DOCUMENT} element={<Documents />} />
                    <Route path={ROUTES.DOCUMENT_DETAILS} element={<Documents />} />
                    <Route path={ROUTES.REQUESTS} element={<Requests />} />
                    <Route path={ROUTES.SUPPORT} element={<Support />} />
                    <Route path={ROUTES.SAVED_FOR_LATER} element={<SavedForLater />} />
                    <Route path={ROUTES.ANALYTICS} element={canAccessOrderAnalytics(hasPermission, user) ? <Analytics /> : <NotAuthorized />} />
                    <Route path={ROUTES.USER_ANALYTICS} element={canAccessUserAnalytics(hasPermission, user) ? <UserAnalytics /> : <NotAuthorized />} />
                    <Route path={ROUTES.SERVICES} element={<Services />} />
                    <Route path={ROUTES.SEARCH_RESULTS} element={<SearchResults />} />
                    <Route path={ROUTES.NOTIFICATIONS} element={<NotificationsPage />} />
                    <Route path={`${ROUTES.FINDER}/:product_id`} element={<PDFProductLinkMachineFinder />} />
                    <Route path={ROUTES.MARKDOWN} element={<MarkdownHelpPage />} />

                    <Route path={ROUTES.PAGE_NOT_FOUND} element={<PageNotFound />} />
                </Routes>
            </Container>
            <Footer />
            <ScrollToTop />
        </Box>
    )
}

export default DefaultLayout
